import { createPortal } from 'react-dom';

type Props = {
  anchorEl?: Element;
  children: React.ReactNode;
  disablePortal?: boolean;
};

export const Portal = ({
  anchorEl,
  children,
  disablePortal,
}: Props) => {

  if (!disablePortal) {
    return createPortal(children, anchorEl || document.body);
  } else {
    return (
      <>
        {children}
      </>
    );
  }
};